<template>
  <div>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      size="mini"
      :height="scrollY"
      :scroll-x="{enabled: true}"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="storageRoom.name" title="business.label.storageRoomName" />
      <vxe-column field="zone.name" title="business.label.zoneName" />
      <vxe-column field="no" sortable title="business.label.outlets" />
      <vxe-column field="dimension.volume" title="business.label.volume" />
      <vxe-column field="occupiedCapacity" title="business.label.occupiedCapacity" />
    </vxe-table>
    <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
  </div>
</template>

<script>
import { findAll, post } from '@/api/Api'
import Api from '@/api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'PackingPositionLightOff',
    data() {
      return {
        data: [],
        loading: false,
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.8075),// 表格竖向滚动条
        page: 1,
        size: 20,
        contentSize: 0,
        args: {
          'locationType': 15,
          'locationStatus': 3,
          'positionType.id': '127620358585573311',
          'confirmable': true
        }
      }
    },
    props: {
      commandStatus: {
        type: Array,
        default: () => []
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      pageChange({ currentPage, pageSize }) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      getData() {
        this.loading = true
        findAll('locationFactory', this.args, this.page, this.size).then(res => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result
          }
        }).finally(() => {
          this.loading = false
        })
      },
      lightOff() {
        let selectedRow = this.$refs.table.getCurrentRecord()
        if (selectedRow == null) {
          this.$warning({ title: '请选择对应的格口再执行操作', centered: true })
        }
        this.loading = true
        post(Api.commandCircleComplete, { type: 'generalHandler' }, { 'location.no': selectedRow.no }).then(res => {
          if (res.success) {
            this.$message.success('灭灯成功')
            this.getData()
          }
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>
